<template>
  <div>
    <b-modal
      ref="tmrLogModal"
      :title="`${buttonItem.name} 사용기록`"
      hide-footer
      centered
      size="md"
    >
      <div class="tmr-log-wrapper">

        <!-- 날짜 선택 -->
        <div class="date-hint">▽ 날짜를 선택해주세요 ▽</div>
        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text style="background:#e8f5e9; border-color:#a5d6a7;">
              <feather-icon icon="CalendarIcon" size="16" />
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            v-model="selectedYearMonth"
            type="month"
            style="border-color:#a5d6a7; font-size:1rem;"
          />
        </b-input-group>

        <!-- 테이블 헤더 -->
        <div class="log-table-wrap">
          <div class="log-header">
            <span class="col-amount">배합량</span>
            <span class="divider">/</span>
            <span class="col-ratio">배합비</span>
            <span class="divider">/</span>
            <span class="col-date">날짜</span>
            <span class="divider">/</span>
            <span class="col-time">배합시간</span>
          </div>

          <!-- 로그 리스트 -->
          <div class="log-scroll">
            <div
              v-for="(log, idx) in filteredLogs"
              :key="idx"
              class="log-row"
              :class="{ 'log-row--zero': log.amount === 0 }"
            >
              <span class="col-amount">
                {{ log.amount === 0 ? '0 kg' : `${log.amount.toLocaleString()}kg` }}
              </span>
              <span class="divider">/</span>
              <span class="col-ratio">{{ log.ratio }}</span>
              <span class="divider">/</span>
              <span class="col-date">{{ log.date.slice(5) }}</span>
              <span class="divider">/</span>
              <span class="col-time">{{ log.amount === 0 ? '0분' : `${log.mixTime}분` }}</span>
            </div>
            <div v-if="filteredLogs.length === 0" class="log-empty">
              해당 월의 기록이 없습니다.
            </div>
          </div>
        </div>

        <!-- 닫기 버튼 -->
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" @click="close">닫기</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupText,
} from 'bootstrap-vue'

export default {
  name: 'TmrMixerLogModal',
  components: {
    BModal,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupText,
  },
  props: {
    buttonItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedYearMonth: '2026-04',

      // 하드코딩 테스트 데이터 (date: 'yyyy-mm-dd' 형식)
      allLogs: [
        { amount: 12241, ratio: '4:2:2:1:1', date: '2026-04-01', mixTime: 45 },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-02', mixTime: 0  },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-03', mixTime: 0  },
        { amount: 11981, ratio: '4:2:2:1:1', date: '2026-04-04', mixTime: 45 },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-05', mixTime: 0  },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-06', mixTime: 0  },
        { amount: 12532, ratio: '4:2:2:1:1', date: '2026-04-07', mixTime: 45 },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-08', mixTime: 0  },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-09', mixTime: 0  },
        { amount: 0,     ratio: '4:2:2:1:1', date: '2026-04-10', mixTime: 0  },
        { amount: 11845, ratio: '4:2:2:1:1', date: '2026-04-11', mixTime: 45 },
      ],
    }
  },
  computed: {
    filteredLogs() {
      // selectedYearMonth = "2026-04", date = "2026-04-01"
      return this.allLogs.filter(log => log.date.startsWith(this.selectedYearMonth))
    },
  },
  methods: {
    open() {
      this.$refs.tmrLogModal.show()
    },
    close() {
      this.$refs.tmrLogModal.hide()
    },
  },
}
</script>

<style scoped>
.tmr-log-wrapper {
  padding: 0 0.25rem;
}

.date-hint {
  text-align: center;
  font-size: 0.8rem;
  color: #777;
  margin-bottom: 0.4rem;
}

.log-table-wrap {
  border: 1px solid #c8e6c9;
  border-radius: 6px;
  overflow: hidden;
}

.log-header {
  display: flex;
  align-items: center;
  background-color: #e8f5e9;
  padding: 0.45rem 0.75rem;
  font-weight: 700;
  font-size: 0.82rem;
  color: #2e7d32;
  border-bottom: 1px solid #c8e6c9;
}

.log-scroll {
  max-height: 320px;
  overflow-y: auto;
}

.log-row {
  display: flex;
  align-items: center;
  padding: 0.38rem 0.75rem;
  font-size: 0.82rem;
  border-bottom: 1px solid #f1f8f1;
  color: #333;
}

.log-row:last-child {
  border-bottom: none;
}

.log-row--zero {
  color: #aaa;
}

.log-row:hover {
  background-color: #f9fbe7;
}

.divider {
  margin: 0 0.2rem;
  color: #bbb;
  flex-shrink: 0;
}

.col-amount {
  flex: 2;
  text-align: right;
  min-width: 0;
}

.col-ratio {
  flex: 2;
  text-align: center;
  min-width: 0;
}

.col-date {
  flex: 1.5;
  text-align: center;
  min-width: 0;
}

.col-time {
  flex: 1.5;
  text-align: center;
  min-width: 0;
}

.log-empty {
  text-align: center;
  padding: 2rem;
  color: #aaa;
  font-size: 0.85rem;
}
</style>
